import OpenAI from 'openai';
import { AI_CONFIG } from '../config/ai-config';
import trainingData from '../data/content.json';

if (!AI_CONFIG.apiKey) {
  throw new Error('OpenAI API key is not configured. Please add REACT_APP_OPENAI_API_KEY to your .env file');
}

const openai = new OpenAI({
  apiKey: AI_CONFIG.apiKey,
  dangerouslyAllowBrowser: true
});

async function generateResponse(userMessage, conversationHistory = []) {
  try {
    // Get relevant content from our knowledge base
    const relevantContent = trainingData.find(content => 
      userMessage.toLowerCase().includes(content.title.toLowerCase()) ||
      content.content.toLowerCase().includes(userMessage.toLowerCase())
    );

    // Create system message with context
    const systemMessage = {
      role: "system",
      content: `You are Luna, a friendly guide who helps users discover relevant information and resources from The School of Life. 
      You have an ongoing relationship with Mike, who you've been helping with his personal development journey.
      Key things about Mike:
      - He's interested in sports and cars
      - He's been doing daily walks as part of his well-being routine
      - He's been exploring personal development through The School of Life resources
      Remember to be warm and personal, referring to your previous conversations and his ongoing progress.
      ${relevantContent ? `Relevant content: ${relevantContent.content}` : ''}`
    };

    const response = await openai.chat.completions.create({
      model: "gpt-3.5-turbo",
      messages: [
        systemMessage,
        ...conversationHistory,
        { role: "user", content: userMessage }
      ],
      temperature: 0.7,
      max_tokens: 500
    });

    return response.choices[0].message.content;
  } catch (error) {
    console.error('AI Service Error:', error);
    throw error;
  }
}

// We'll implement this later when we're ready for fine-tuning
async function saveConversationForTraining(conversation) {
  console.log('Saving conversation for future fine-tuning:', conversation);
}

export default {
  generateResponse,
  saveConversationForTraining
}; 